module.exports = new __parcel__URL__("quickSummaryUpsellBannerDark.e27429f6.svg").toString();